const baseFields = `
  id
  updatedAt
  createdAt
  status
`;

export default baseFields;
